import React from 'react';
import Resource from '../../../common/Resource'
import Panel from '../../../common/layout/Panel'

export default class  extends React.Component {
    render() {
        var accountId = this.props.match.params.account_id;
        const data = {
            url: `/admin/clients/accounts/${accountId}/client_webhooks`,
            data: {
                data: [],
                metadata: []
            },
            loading: false,
            metadata:
                [
                    {
                        'label': 'id',
                        'source': 'client_webhook_id',
                        'type': 'primary',
                        'editable': false,
                        'visible': false
                    },
                    {
                        'label': 'Name',
                        'source': 'name',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'Webhook Name'
                    },
                    {
                        'label': 'URL',
                        'source': 'ATRURL',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'http://host.domain.com/path'
                    },
                    {
                        'label': 'Skip SSL Cert Verif.',
                        'source': 'ATRSKIPSSLVERIFY',
                        'type': 'checkbox',
                        'editable': true,
                        'visible': true,
                        'default': false
                    },
                    {
                        'label': 'Auth Header',
                        'source': 'ATRAUTHHEADER',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'header value'
                    },
                    {
                        'label': 'API Method',
                        'source': 'ATRMETHOD',
                        'type': 'select',
                        'editable': true,
                        'visible': true
                    },
                    {
                        'label': 'Payload type',
                        'source': 'ATRPOSTPAYLOAD',
                        'type': 'select',
                        'editable': true,
                        'visible': true
                    },
                    {
                        'label': 'Two Step Auth',
                        'source': 'ATRTWOSTEP',
                        'type': 'checkbox',
                        'editable': true,
                        'visible': true,
                        'default': false
                    },
                    {
                        'label': 'Preauth URL',
                        'source': 'ATRPREAUTHURL',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'http://host.domain.com/preauth'
                    },
                    {
                        'label': 'Username',
                        'source': 'ATRUSERNAME',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'username'
                    },
                    {
                        'label': 'Password',
                        'source': 'ATRPASSWORD',
                        'type': 'password',
                        'editable': true,
                        'visible': true
                    },
                    {
                        'label' : 'Actions',
                        'type': 'action_buttons'
                    }
                ]
        }
        return (
            <Panel title = "Client Webhooks">
                <Resource
                    addButtonText = "Add Client Webhook"
                    data = {data}
                    {...this.props}
                />
            </Panel>
        )
    }
}
